import React from 'react'
import Headroom from 'react-headroom'
import Link from 'components/base/link'
import { fonts, colors } from '../../themes'
import Grid from 'material-ui/Grid';
import presets from 'lib/presets'

const stepData = [
  {
    title: 'Create profile',
    description: 'We auto-populate your info from Doximity and let you customize it.',
  },
  {
    title: 'Upload Credentialing Info',
    description: "We securely store it in the cloud so that you can use the same information for multiple hospitals.",
  },
  {
    title: 'Connect with hospitals',
    description: "Filter local hospitals based on your experience & proximity, then connect with those you like.",
  },
  {
    title: 'Get to work',
    description: "Pick up shifts whenever YOU want.",
  },
]

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch'
  },
  center: {
    border: `3px solid ${colors.green}`,
    height: '150px',
    position: 'relative'
  },
  numberCircle: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.green,
    top: -5,
    width: 35,
    height: 35,
    borderRadius: '100%',
    color: colors.white,
    marginLeft: -17.5,
  },
  left: {
    display: 'none',
    [presets.Tablet]: {
      display: 'flex',
      flex: 0.5,
    },
    marginTop: '-120px',
    paddingRight: '60px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    textAlign: 'right',
  },
  right: {
    marginTop: '-120px',
    display: 'flex',
    [presets.Tablet]: {
      display: 'flex',
      flex: 0.5,
      paddingLeft: '60px',
    },
    width: '90%',
    paddingLeft: '30px',
    paddingRight: '10px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  title: {
    color: colors.white,
    alignSelf: 'stretch',
    marginBottom: '10px',
  },
  description: {
    color: colors.white,
    alignSelf: 'stretch',
    margin: 0,
  }
}

const Step = ({ step, title, description }) => {
  const text = (
    <div>
      <h3 css={styles.title}>{title}</h3>
      <p css={styles.description}>{description}</p>
    </div>
  )
  return (
    <div css={styles.row}>
      <div css={styles.left}>
        { step % 2 !== 0 &&
          text
        }
      </div>
      <div css={{...styles.center, border: step === stepData.length ? null : styles.center.border}}>
        <div css={styles.numberCircle}>
          {step}
        </div>
      </div>
      <div css={styles.right}>
        <div css={{ [presets.Tablet]: { display: step % 2 === 0 ? null : 'none' } }} >
          {text}
        </div>
      </div>
    </div>
  )
}
  

const Steps = () => {
  const stepElements = stepData.map((currentStep, index) => <Step {...currentStep} step={index + 1} />)
  return (
    <div css={styles.conatiner}>
      {stepElements}
    </div>
  )
}

export default Steps


// WEBPACK FOOTER //
// ./src/components/hybrid/steps.js